import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { FacebookService, LoginResponse } from 'ngx-facebook';
import { UserFacebookService } from 'src/app/services/facebook.service';

@Component({
  selector: 'app-social-media-share',
  templateUrl: './social-media-share.component.html',
  styleUrls: ['./social-media-share.component.scss']
})
export class SocialMediaShareComponent implements OnInit, AfterViewInit {

  private profileUrl: string;
  constructor(private fb: FacebookService, private userFbService: UserFacebookService) 
  {
    document.addEventListener("click", () => {}, true);  
  }

  ngAfterViewInit(): void
  {
    var linkedInSharePluginScriptElement = document.createElement("script");
    linkedInSharePluginScriptElement.type = "text/javascript";
    linkedInSharePluginScriptElement.src = "https://platform.linkedin.com/in.js";
    linkedInSharePluginScriptElement.text = "lang: en_US";
    linkedInSharePluginScriptElement.textContent = "lang: en_US";

    var linkedInShareButtonScriptElement = document.createElement("script");
    linkedInShareButtonScriptElement.type = "IN/Share";
    linkedInShareButtonScriptElement.setAttribute("data-url", "https://https://uvuyo-prod.firebaseapp.com/");

    document.getElementById("linkedInShareBtnWrapper").appendChild(linkedInSharePluginScriptElement);
    document.getElementById("linkedInShareBtnWrapper").appendChild(linkedInShareButtonScriptElement);
  }

  ngOnInit(): void {
    this.profileUrl = window.location.href;
  }

  openLink($event: any) 
  {
    $event.preventDefault();
    if($event.currentTarget.id === "fbLnkBtn")
    {
      console.log("Open link for FB has been cliked");
      document.getElementById("fbShareBtn").setAttribute("data-href", this.profileUrl);
      document.getElementById("fbShareBtn").click();
    }

    if($event.currentTarget.id === "twitterLnkBtn")
    {
      const pageUrl = window.location.href;
      window.open('https://twitter.com/intent/tweet?text=' + encodeURIComponent(document.title) + '&url=' + encodeURIComponent(pageUrl), '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=350,width=600');
    }
  }

  private getUserPageAccessToken(userId: string, userAccessToken: string): any
  {
    var requestResponse: string;
    this.userFbService.getPageAccessToken(userId, userAccessToken).subscribe({
      next: (response: any) => 
      {
        requestResponse = response;
      },
      error: (errorMsg: any) => 
      {
        console.log(errorMsg);  
      },
    });

    return requestResponse;
  } 
}
